export const columnDesign = ({ headerName, field, valueFormatter, sortable = true, filter = true, ...config }) => {
    const defaultFormatter = (params) => params.value !== null && params.value !== undefined && params.value !== "" ? params.value : "-";

    return {
        headerName,
        field,
        sortable: sortable,
        filter: filter,
        valueFormatter: valueFormatter || defaultFormatter,
        ...config,
        
    };
};